import { isEmailValid } from "utils/validations";

const mailErrorChecker = (mail) =>
  isEmailValid(mail) ? false : "Invalid mail format.";
const useMailValidator = () => {
  return { mailErrorChecker };
};
export default useMailValidator;
